(function () {

    'use strict';

    angular.module('iplusjs.integration.pksangemeldethinweis', [
        'iplusjs.authentication',
        'iplusjs.integration',
        'iplusjs.utils.misc',
        'iplusjs.navigation',
        'lodash',
        'modernizr'
    ])
        .component('iplusjsPksAngemeldetHinweis', {
            templateUrl: 'common/integration/pksAngemeldetHinweis.html',
            bindings: {
                cssClassMainWidth: '@cssClassMainWidth'
            },
            controller: PksAngemeldetHinweisController,
            controllerAs: 'pksVm'
        });

    PksAngemeldetHinweisController.$inject = [
        '$state',
        '$timeout',
        '$window',
        '$injector',
        'lodash',
        'modernizr',
        'AngebotModel',
        'BasisAngebotService',
        'IntegrationService',
        'AuthenticationService',
        'MiscUtilsService',
        'NavigationService'
    ];

    function PksAngemeldetHinweisController($state, $timeout, $window, $injector, _, modernizr, AngebotModel, BasisAngebotService, IntegrationService, AuthenticationService, MiscUtilsService, NavigationService) {
        var vm = this,
            $sessionStorage,
            angebotModel;

        $sessionStorage = $injector.has('$sessionStorage') && $injector.get('$sessionStorage') || {};

        vm.$onInit = onInit;
        vm.$doCheck = doCheck;
        vm.reloadAnonym = reloadAnonym;
        vm.isLoggedIn = isLoggedIn;
        vm.isVisible = isVisible;

        function onInit() {
            activate();
        }

        function doCheck() {
            getPKSLoginOptions();
        }

        function activate() {
            angebotModel = AngebotModel.get();

            IntegrationService.setIntegrationParams({
                loginDialog: false
            });

            vm.options = {};
            vm.hideReloadAnonymMessage = false;
            vm.isAppModus = MiscUtilsService.isAppModus();
            vm.integrationParamHidePksLogin = IntegrationService.getIntegrationParams().hidePksLogin;
        }

        function reloadAnonym() {
            vm.integrationParamHidePksLogin = true;
            resetSessionStorage();

            AuthenticationService.clearSession();
            IntegrationService.setIntegrationParams({
                hidePksLogin: true,
                reload: true,
                username: null,
                password: null,
                isTokenLogin: false,
                vertragsnummer: null,
                vertragsKennzeichen: null
            });
            $sessionStorage.reloadAnonym = true;

            $timeout(function () {
                $window.confirmBeforeUnload = false;
                $window.location.href = $window.location.href; //$window.location.reload();
            }, 150);
        }

        function isLoggedIn() {
            return (
                AuthenticationService.getSession().tokenLoginSession ||
                IntegrationService.getIntegrationParams().isTokenLogin
            );
        }

        function isVisible() {
            return (
                !vm.integrationParamHidePksLogin &&
                NavigationService.get(_.get($state, '$current.name')).pksLogin === true &&
                !vm.isAppModus &&
                isLoggedIn() &&
                !angebotModel.wurdeGeladen &&
                !angebotModel.wurdeKopiert &&
                BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT')
            );
        }

        function resetSessionStorage() {
            if (modernizr.sessionstorage) {
                if (_.get(vm.options, 'sessionStorage')) {
                    _.forOwn(_.get(vm.options, 'sessionStorage'), function (val, key) {
                        $window.sessionStorage.removeItem(key);
                    });
                }
            }
        }

        function getPKSLoginOptions() {
            if (isVisible()) {
                _.merge(vm.options, NavigationService.getActive().pksLoginOptions);
            }
        }
    }

})();
